<template>
 <section class="section">
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
        <div class="admin-page-group">
          <h1 class="admin-page">Crear plato</h1>
          <router-link to="/platos" class="btn-link pull-right"><i class="fa fa-angle-left"></i> <span class="semibold">Volver al listado de Platos</span></router-link>
        </div>
        <div class="box-style line-top">
          <form class="form smart-form">
            <div class="box-body">  
              <div class="row">
                <div class="col-xs-12">
                  <div>
                    <span class="label label-danger" v-if="!$v.datosPlato.categoria.required && mostrarErrores">Debe seleccionar una categoría</span>
                  </div>
                  <div class="form-group">
                    <label>Tipo de plato</label>
                    <div class="inline-group margin-top-10">
                      <label class="radio" v-for="categoria in categorias">
                        <input type="radio" name="radio" v-model="datosPlato.categoria" :value="categoria._id">
                        <i></i><span class="size-16">{{categoria.nombre}}</span>
                      </label>
                    </div>
                  </div>  
                  <div class="form-group">
                    <label>Nombre del Plato</label>
                    <div class="input">
                      <input type="text" v-model="datosPlato.nombre" class="form-control" placeholder="Ej: Vacío al horno con papas bravas"/>
                      <span class="label label-danger" v-if="!$v.datosPlato.nombre.required  && mostrarErrores">Campo requerido</span><span class="label label-danger" v-if="!$v.datosPlato.nombre.minLength">El campo debe tener por lo menos {{$v.datosPlato.nombre.$params.minLength.min  && mostrarErrores}} caracteres.</span>
                    </div>
                  </div>              
                  <div class="form-group">
                    <label>Descripción</label>
                    <div class="textarea">
                      <textarea rows="5" v-model="datosPlato.descripcion" class="form-control" placeholder="Escribe una descripción breve  del plato mencionando los principales ingredientes que se han utilizado, y redacta de forma atractiva para que los comenzales se tienten!"></textarea>
                      <span class="label label-danger" v-if="!$v.datosPlato.descripcion.required && mostrarErrores">Campo requerido</span>
                    </div>
                  </div>              
                  <div class="form-group" v-if="!imagenCargada">
                    <label>Carga de la imagen</label>
                    <uploader :url="urlUpload" @upload-correct="onUploadCorrect" />
                    <!-- <div class="dropzone">
                      <input type="file" name="image" accept="image/png, image/jpeg" />
                    </div> -->
                  </div>
                  <div class="form-group" v-else>
                    <label>Imagen</label>
                    <div>
                      <button class="btn btn-fill" @click.prevent="cambiarImagen">Cambiar imagen</button>
                    </div>
                    <img :src="datosPlato.urlImagen" class="img" alt="">
                  </div>
                  <div v-if="datosPlato && datosPlato.receta" class="panel-group smart-accordion-default" id="accordion">
                    <div class="panel-heading">
                      <div class="panel-title box-header">
                        <a data-toggle="collapse" :href="'#nutricional'">
                          <i class="fa fa-lg fa-angle-down pull-right"></i>
                          <i class="fa fa-lg fa-angle-up pull-right"></i>
                          <h2><b>Informacion nutricional</b></h2>
                        </a>
                      </div>
                    </div>
                    <div :id="'nutricional'" class="panel-collapse collapse">
                      <div class="row">
                        <div class="col-md-7">
                          <div class="form-group">
                            <label>Ingrediente (en singular)</label>
                            <div class="input-typeahead">
                              <vue-bootstrap-typeahead
                                  :data="ingredients"
                                  v-model="ingredientName"
                                  ref="ingredientSelector"
                                  :serializer="s => s.create ? '* ' + s.name: s.name"
                                  placeholder="Escribi el ingrediente en singular..."
                                  @hit="selectedIngredient = $event"
                                >                                  
                                </vue-bootstrap-typeahead>
                            </div>
                          </div>                        
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Unidad de Medida</label>
                            <div class="input">
                              <select ref="slMeasureUnits" id="" v-model="recipeIngredient.measureUnit" class="form-control select2" style="width: 100%;">
                                <option v-for="mu in measureUnits" :value="mu._id" :key="mu._id">{{mu.name}}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-group">
                            <label>Cantidad</label>
                            <div class="input">
                              <input type="number" v-model="recipeIngredient.amount" class="form-control" placeholder="Cantidad"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12 text-center">
                            <button type="button" class="btn btn-fill" @click="addIngredient()">
                              <span v-if="selectedIngrediendIdx > -1"><i class="fa fa-pencil"></i> Cambiar</span>
                              <span v-else><i class="fa fa-plus"></i> Agregar</span>
                            </button>
                        </div>
                      </div> 
                      <div class="row" style="margin-top:10px;">
                        <div class="col-md-12">
                          <table class="table table-hover table-stripped table-no-first-pad">
                            <thead>
                              <tr>
                                <th>Ingrediente (en singular)</th>
                                <th>Cantidad</th>                      
                                <th class="text-right">Acciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="ing,idx in datosPlato.receta.ingredientes">
                                <td>{{ing.name}}</td>
                                <td>{{ing.amount}} {{measureUnitsById[ing.measureUnit].name}}</td>
                                <td class="text-right">
                                  <a class="btn btn-xs btn-ghost" type="button" @click="editIngredient(ing, idx)">
                                    <i class="fa fa-actions fa-pencil"></i>
                                  </a>
                                  <a v-if="selectedIngrediendIdx === -1" class="btn btn-xs btn-ghost text-danger" type="button" @click="removeIngredient(idx)">
                                    <i class="fa fa-actions fa-times"></i>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12 text-right">
                          <button class="btn btn-brand" v-if="datosPlato.receta.edamam&&(recipeStatus==='ANALYZED'||recipeStatus==='SAVED')" type="button" @click="showNutritionalInfo()">Ver tabla</button>
                          <button class="btn btn-fill" v-if="recipeStatus==='ANALYZE'" type="button" @click="analyze()">Analizar</button>
                          <button v-if="datosPlato._id&&recipeStatus==='ANALYZED'" class="btn btn-fill"  type="button" @click="saveRecipe()">Guardar Receta</button>
                        </div>
                      </div> 
    <div class="modal" ref="modalInfo" role="dialog">
      <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                </div>
                  <div class="modal-body">
                          <div class="row" v-if="datosPlato.receta&&datosPlato.receta.edamam&&datosPlato.receta.edamam.totals">
                                <div class="col-md-10 col-md-offset-1">
                                  <section class="performance-facts" id="performance-facts">
                                      <div class="performance-facts__header">
                                          <h1 class="performance-facts__title">Información nutricional</h1>
                                      </div>
                                      <table class="performance-facts__table">
                                          <thead>
                                              <tr>
                                                  <th colspan="3" class="amps">Cantidades por Porción</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr>
                                                  <th colspan="2" id="lkcal-val-cal"><b>Calorias</b></th>
                                                  <td class="nob">{{datosPlato.receta.edamam.totals.totalCal}}</td>
                                              </tr>
                                              <tr class="thick-row">
                                                  <td colspan="3" class="small-info"><b>% del valor diario*</b></td>
                                              </tr>
                                              <tr>
                                                  <th colspan="2"><b>Grasas totales</b> {{datosPlato.receta.edamam.totals.FAT}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyFAT}}</b></td>
                                              </tr>
                                              <tr>
                                                  <td class="blank-cell"></td>
                                                  <th>Grasas Saturadas {{datosPlato.receta.edamam.totals.FASAT}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyFASAT}}</b></td>
                                              </tr>
                                              <tr>
                                                  <td class="blank-cell"></td>
                                                  <th>Grasas Trans {{datosPlato.receta.edamam.totals.FATRN}}</th>
                                                  <td></td>
                                              </tr>
                                              <tr>
                                                  <th colspan="2"><b>Colesterol</b> {{datosPlato.receta.edamam.totals.CHOLE}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyCHOLE}}</b></td>
                                              </tr>
                                              <tr>
                                                  <th colspan="2"><b>Sodio</b> {{datosPlato.receta.edamam.totals.NA}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyNA}}</b></td>
                                              </tr>
                                              <tr>
                                                  <th colspan="2"><b>Carbohidratos totales</b> {{datosPlato.receta.edamam.totals.CHOCDF}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyCHOCDF}}</b></td>
                                              </tr>
                                              <tr>
                                                  <td class="blank-cell"></td>
                                                  <th>Fibra {{datosPlato.receta.edamam.totals.FIBTG}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyFIBTG}}</b></td>
                                              </tr>
                                              <tr>
                                                  <td class="blank-cell"></td>
                                                  <th>Azúcares {{datosPlato.receta.edamam.totals.SUGAR}}</th>
                                                  <td></td>
                                              </tr>
                                              <tr>
                                                  <td class="blank-cell"></td>
                                                  <th>Azúcar agregada {{datosPlato.receta.edamam.totals.SUGARadded}}</th>
                                                  <td></td>
                                              </tr>
                                              <tr class="thick-end">
                                                  <th colspan="2"><b>Proteínas</b> {{datosPlato.receta.edamam.totals.PROCNT}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyPROCNT}}</b></td>
                                              </tr>
                                          </tbody>
                                      </table>
                                      <table class="performance-facts__table--grid">
                                          <tbody>
                                              <tr>
                                                  <th>Vitamin D {{datosPlato.receta.edamam.totals.VITD}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyVITD}}</b></td>
                                              </tr>
                                              <tr>
                                                  <th>Calcio {{datosPlato.receta.edamam.totals.CA}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyCA}}</b></td>
                                              </tr>
                                              <tr>
                                                  <th>Hierro {{datosPlato.receta.edamam.totals.FE}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyFE}}</b></td>
                                              </tr>
                                              <tr class="thin-end">
                                                  <th>Potasio {{datosPlato.receta.edamam.totals.K}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyK}}</b></td>
                                              </tr>
                                          </tbody>
                                      </table>
                                      <p class="small-info" id="small-nutrition-info">* Porcentaje de valor diario calculado sobre la base de una dieta de 2000 calorías</p>
                                  </section>
                                </div>
                          </div>                    
                  </div>
            </div>
      </div>
    </div>

                    </div>
                  </div>

                  <div class="form-group">
                    <label>Observaciones</label>
                    <div class="textarea">
                      <textarea rows="5" v-model="datosPlato.observaciones" class="form-control" placeholder="Algunos datos extras que sea necesario comunicarle a tus comenzales..."></textarea>
                    </div>
                  </div>
                  <div class="clear-xs"></div>
                  <div class="form-group">
                    <h3 class="title-label">CARACTERÍSTICAS</h3>
                    <div class="inline-group margin-top-10">
                      <label class="checkbox">
                        <input type="checkbox" v-model="datosPlato.aptoCeliacos">
                        <i></i>Sin Gluten</label>
                        <label class="checkbox">
                        <input type="checkbox" v-model="datosPlato.picante">
                        <i></i>Picante</label>
                      <label class="checkbox">
                        <input type="checkbox" v-model="datosPlato.vegetariano">
                        <i></i>Vegetariano</label>
                      <label class="checkbox">
                        <input type="checkbox" v-model="datosPlato.vegano">
                        <i></i>Vegano</label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="clear-sm"></div>
                  <div class="form-action text-center">
                    <button type="button" class="btn btn-fill" @click="onClickGuardar">GUARDAR</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
</template>
<script>
  import {minLength, required} from 'vuelidate/lib/validators'
  import Uploader from './../Shared/Uploader'
  import $ from 'jquery'
  import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
  import _ from 'underscore'

  export default {
    components: {
      'uploader': Uploader,
      'vue-bootstrap-typeahead': VueBootstrapTypeahead
    },
    data () {
      return {
        categorias: [],
        ingredients: [],
        measureUnitsById: {},
        ingredientName: '',
        selectedIngredient: {},
        selectedIngrediendIdx: -1,
        measureUnits: [],
        recipeIngredient: {},
        recipeStatus: 'CLEAN',
        datosPlato: {
          _id: undefined,
          categoria: undefined,
          nombre: '',
          descripcion: '',
          observaciones: '',
          aptoCeliacos: false,
          vegano: false,
          vegetariano: false,
          picante: false,
          urlImagen: '',
          urlThumb: ''
        },
        imagenCargada: false,
        mostrarErrores: false,
        urlUpload: '/api/uploads/imagenplato'
      }
    },
    created () {
      const me = this
      const idPlato = me.$route.params.id
      me.$http.get('/api/platos/initform', {params: {id: idPlato}}).then(({body}) => {
        me.categorias = body.categorias
        me.measureUnits = body.measureUnits
        me.measureUnits.forEach((mu) => {
          me.measureUnitsById[mu._id] = mu
        })
        const plato = body.plato
        if (plato) {
          me.datosPlato = {
            _id: plato._id,
            categoria: plato.categoria,
            nombre: plato.nombre,
            descripcion: plato.descripcion,
            observaciones: plato.observaciones,
            receta: plato.receta,
            aptoCeliacos: plato.aptoCeliacos || false,
            vegano: plato.vegano || false,
            vegetariano: plato.vegetariano || false,
            picante: plato.picante || false,
            urlImagen: plato.urlImagen,
            urlThumb: plato.urlThumb
          }
          me.recipeStatus = 'ANALYZE'
          if (me.datosPlato.receta && me.datosPlato.receta.edamam) {
            me.recipeStatus = 'SAVED'
          }
          me.imagenCargada = true
        }
      }, (err) => {
        console.log('error', err)
      }).then(() => {
        $(me.$refs.slMeasureUnits).select2({
          selectOnClose: true
        }).on('change', (e) => {
          me.recipeIngredient.measureUnit = me.$refs.slMeasureUnits.value
        })
      })
    },
    validations: {
      datosPlato: {
        nombre: {
          required,
          minLength: minLength(3)
        },
        categoria: {
          required
        },
        descripcion: {
          required
        }
      }
    },
    watch: {
      ingredientName: _.debounce(function (addr) { this.searchIngredients(addr) }, 300)
    },
    methods: {
      async searchIngredients (query) {
        const res = await fetch('/api/platos/ingredients?q=' + query)
        const suggestions = await res.json()
        this.ingredients = suggestions
      },
      showNutritionalInfo () {
        const me = this
        $(me.$refs.modalInfo).modal()
      },
      closeNutritionalInfo () {
        const me = this
        $(me.$refs.modalInfo).modal('hide')
      },
      editIngredient (ing, idx) {
        const me = this
        me.ingredientName = ing.name
        me.selectedIngredient = {name: ing.name, english: ing.english}
        me.$refs.ingredientSelector.handleInput(me.selectedIngredient.name)
        me.recipeIngredient = Object.assign({}, ing)
        $(me.$refs.slMeasureUnits).val(ing.measureUnit).trigger('change')
        me.selectedIngrediendIdx = idx
      },
      saveRecipe () {
        const me = this
        me.$http.post('/api/platos/' + me.datosPlato._id + '/recipe', me.datosPlato.receta).then(({body}) => {
          me.recipeStatus = 'SAVED'
          me.$emit('mostrar-notificacion', 'La receta se guardó correctamente', 'success')
        }, (err) => {
          console.log('error', err)
        })
      },
      analyze () {
        const me = this
        me.datosPlato.receta.ingredientes.forEach((ing) => {
          ing.measure = me.measureUnitsById[ing.measureUnit].english
        })
        me.datosPlato.receta.title = me.datosPlato.nombre
        me.$emit('activar-modal')
        me.$http.post('/api/platos/analyze', me.datosPlato.receta).then(({body}) => {
          me.datosPlato.receta = body
          me.recipeStatus = 'ANALYZED'
          me.$emit('cerrar-modal')
        }, (err) => {
          me.$emit('cerrar-modal')
          console.log('error', err)
          me.$emit('mostrar-notificacion', 'No se pudo analizar la receta, por favor controle los ingredientes.', 'error')
        })
      },
      removeIngredient (idx) {
        const me = this
        me.recipeStatus = 'ANALYZE'
        me.datosPlato.receta.ingredientes.splice(idx, 1)
      },
      addIngredient () {
        const me = this
        if (me.selectedIngredient && me.selectedIngredient.name && me.ingredientName && me.recipeIngredient.amount && me.recipeIngredient.measureUnit) {
          if (!me.datosPlato.receta.ingredientes) {
            me.datosPlato.receta.ingredientes = []
          }
          let recIngredient = me.recipeIngredient
          recIngredient.name = me.selectedIngredient.name
          if (!me.selectedIngredient.create) {
            recIngredient.english = me.selectedIngredient.english
          } else {
            recIngredient.english = undefined
          }
          if (me.selectedIngrediendIdx > -1) {
            me.datosPlato.receta.ingredientes[me.selectedIngrediendIdx] = recIngredient
          } else {
            me.datosPlato.receta.ingredientes.push(recIngredient)
          }
          me.recipeStatus = 'ANALYZE'
          me.ingredientName = ''
          me.recipeIngredient = {}
          me.selectedIngredient = {}
          me.selectedIngrediendIdx = -1
          $(me.$refs.slMeasureUnits).val(null).trigger('change')
          me.$refs.ingredientSelector.handleInput('')
        }
      },
      cambiarImagen () {
        const me = this
        me.imagenCargada = false
      },
      onClickGuardar () {
        const me = this
        if (me.$v.$invalid) {
          me.mostrarErrores = true
          return false
        }
        let plato = me.$data.datosPlato
        me.$http.post('/api/platos', plato).then(({body}) => {
          me.$router.push({
            path: '/platos'
          })
        }, (err) => {
          console.log('error', err)
        })
      },
      onUploadCorrect (data) {
        const me = this
        me.datosPlato.urlThumb = data.small
        me.datosPlato.urlImagen = data.large
        me.imagenCargada = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PlatoForm.vue?0cefec19